angular.module('ui.order.orderItemCard.orderItemActions', [])

    .directive('orderItemActions', function () {
        return {
            restrict: 'E',
            scope: {
                executeAction: "&executeAction"
            },
            templateUrl: 'app/ui/order/orderItemCard/orderItemActions/orderItemActions.html',
            controller: 'OrderItemActionsController'
        };
    })

    .controller('OrderItemActionsController', function ($timeout, $scope, toastr, $log, $q, $customisationConfig, usersRepository,
                                                        workflowRepository, orderItemCardDataProvider, permissions, gettextCatalog, focusManagementService) {

        $scope.onExecuteActionButtonClick = onExecuteActionButtonClick;

        orderItemCardDataProvider.onDataChange('OrderItemActionsController', function () {
            initData();
        });

        function transformColor(colorToTransform) {
            var defaultColor = "#8F9499";
            switch (colorToTransform) {
                case "red":
                    return "#EC8678";
                case "green":
                    return "#77DA95";
                case "yellow":
                    return "#EBE176";
                case "violet":
                    return "#AC83E1";
                case "orange":
                    return "#E8B470";
                case "blue":
                    return "#7BB0DE";
                case "grey":
                    return defaultColor;
                default:
                    return defaultColor;
            }
        }

        function initData() {
            var defaultColor = "#8F9499";
            var actionsConfig = $customisationConfig.workflow.actions;

            $scope.orderItem = orderItemCardDataProvider.getOrderItem();
            if (!$scope.orderItem) {
                return;
            }
            $scope.step = $scope.orderItem.$model.stepCode;

            $q.all(
                [
                    usersRepository.getCurrentUser(),
                    workflowRepository.getSteps()
                ])
                .then(function (data) {
                    var restUser = data[0];
                    var steps = data[1];
                    var currentStep = _.find(steps, function (result) {
                        return result.$model.code == $scope.step;
                    });
                    var isCustomer = restUser.isCustomer();
                    var fallbackIconForAction = function (actionCode) {
                        return $customisationConfig.hasResource(function (res) {
                            return _.string.contains(res, actionCode + ".");
                        }) ? actionCode : "workflow";
                    };
                    var actions = [];
                    workflowRepository.getActionsForStep(currentStep.$model.code)
                        .then(function (actionsFromApi) {
                            var promises = [];
                            _.forEach(actionsFromApi, function (value) {
                                var promise = permissions.isActionAllowed(currentStep.$model.id, value.$model.id)
                                    .then(function (isAllowed) {
                                        if (!isAllowed) {
                                            return;
                                        }
                                        var actionConfig = _.find(actionsConfig, function (result) {
                                            return result.code == value.$model.code;
                                        });

                                        actions.push({
                                            code: value.$model.code,
                                            name: value.$model.nameResource,
                                            color: angular.isDefined(actionConfig) && angular.isDefined(actionConfig.color)
                                                ? transformColor(actionConfig.color)
                                                : defaultColor,
                                            uiPriority: angular.isDefined(actionConfig) && angular.isDefined(actionConfig.uiPriority)
                                                ? actionConfig.uiPriority
                                                : Infinity,
                                            iconName: angular.isUndefined(actionConfig)
                                                ? fallbackIconForAction(value.$model.code)
                                                :
                                                (angular.isDefined(actionConfig.publicImageResourceName) && isCustomer
                                                    ? actionConfig.publicImageResourceName
                                                    : (angular.isDefined(actionConfig.imageResourceName)
                                                    ? actionConfig.imageResourceName
                                                    : fallbackIconForAction(value.$model.code)))
                                        });
                                    });
                                promises.push(promise);
                            });
                            if (promises.length > 0) {
                                return $q.all(promises);
                            }
                        })
                        .then(function () {
                            $scope.actions = _.clone(actions);
                            focusManagementService.setFocus();
                        }, function (err) {
                            $scope.actions = [];
                            $log.error("Can't init actions list for orderItem: %s. Cause: %s.", $scope.orderItem
                                ? $scope.orderItem.getId()
                                : undefined, err.message);
                            toastr.error(err.message, gettextCatalog.getString("Can't initialize actions list"));
                        });
                });
        }

        function onExecuteActionButtonClick(actionCode) {
            $scope.executeAction({actionCode: actionCode});
        }



        //region Barcode stuff

        var lastKeys = '';

        function addChar(char) {
            if (char.match(/[A-Za-z0-9_\-]/i)) {
                lastKeys += char;
                while (lastKeys.length > 50) {
                    lastKeys.shift();
                }
            }
        }

        function checkBarcode() {
            if ($scope.actions && $scope.actions.length > 0) {
                for (var i = 0; i < $scope.actions.length; i++) {
                    var actionCode = $scope.actions[i].code;
                    if (lastKeys.endsWith(actionCode)) {
                        lastKeys = '';
                        onExecuteActionButtonClick(actionCode);
                        break;
                    }
                }
            }
        }

        $("#orderItemActionButtonsContainer")
            .keypress(function (e) {
                var code = (e.keyCode ? e.keyCode : e.which);

                if (code == 13) { // Enter key hit
                    checkBarcode();
                }
                else if (code == 9) { // Tab key hit
                    checkBarcode();
                } else {
                    addChar(String.fromCharCode(code));
                }
            });

        //endregion
    })

;